<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { GetDataMethods, PostDataMethods, notificationMethods } from "@/state/helpers";
export default {
    components: {
        Layout,
        PageHeader,
    },
    data() {

        return {
            title: "Balance Recharge",
            items: [
                {
                    text: "Wesal",
                },

            ],
            userData: null,
            FormData: {
                balance: 0,
                commission: 0,
                is_credit: false
            },
            username: "",
            phone: '',
            role: '',
        };

    },
    props: ["id"],

    mounted() {
        // Set the initial number of items
        this.GetUserData();
    },

    methods: {
        ...GetDataMethods,
        ...PostDataMethods,
        ...notificationMethods,
        async submitForm() {
            try {
                // Await the result of the postData call
                const response = await this.postData({ key: "recharge_balance_user/" + this.id, data: this.FormData });
                // Check response status
                if (response.status === 422) {
                    // Validation error (422)
                    await this.makeToast("danger", "Fail", response.data.message);
                } else if (response.status === 500) {
                    // Server error (500)
                    await this.makeToast("danger", "Fail", response.data.message);
                }
                else if (response.status === 400) {
                    //  error (400)
                    await this.makeToast("danger", "Fail", response.data.message);
                } else {
                    // Success response
                    this.makeToast("success", "Success", response.data.message);
                    await this.getAdmin(response.data.data.points)
                    this.$router.push(`/user/${this.id}`);
                }
            } catch (error) {
                // Catch any errors that occur during the API call or toast message display
                this.makeToast("danger", "Error", "An unexpected error occurred.");
                console.error("Error during submitForm:", error);
            }
        },

        async getAdmin(points) {
            const userInfo = localStorage.getItem('user');
            this.user = JSON.parse(userInfo);
            this.user.points = points;
            localStorage.setItem('user', JSON.stringify(this.user));
        },

        async GetUserData() {
            const res = await this.getData("get_user_by_id/" + this.id);
            this.userData = res.data.data.user
            this.FormData.commission = this.userData.commission;
            this.username = this.userData.username;
            this.phone = this.userData.phone;
            this.role = this.userData.role;

        },

        async makeToast(variant = null, body = null, title = null) {
            this.$bvToast.toast(title, {
                title: `${body}`,
                variant: variant,
                solid: true,
            });
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="conteanir" color="#5664d2">
                            <div class="row-main" title="Basic Info">
                                <div class="tab-pane" id="basic-info">
                                    <h4 class="card-title">Balance recharge Information</h4>
                                    <p class="card-title-desc">Fill all information below</p>
                                    <!-- Start From Create User -->
                                    <form @submit.prevent="submitForm">
                                        <div class="row">

                                            <div class="form-group col-lg-2">
                                                <label>User Name</label>
                                                <input v-model="username" type="text" class="form-control"
                                                    placeholder="Name" readonly />
                                            </div>
                                            <div class="col-lg-2">
                                                <div class="form-group">
                                                    <label>Phone</label>
                                                    <input v-model="phone" type="text" placeholder="phone"
                                                        class="form-control" readonly />
                                                </div>
                                            </div>

                                            <div class="col-lg-2">
                                                <div class="form-group">
                                                    <label>Balance</label>
                                                    <input v-model="FormData.balance" type="number" min="0"
                                                        class="form-control" />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <!--Start Commission -->
                                                <div class="col-lg-5">
                                                    <div id="tickets-table_length" class="dataTables_length">
                                                        <label class="d-inline-flex align-items-center">
                                                            Commission
                                                        </label>
                                                        <input v-model="FormData.commission" type="number" min="0"
                                                            step="0.02" class="form-control" />
                                                    </div>
                                                </div>
                                                <!-- End Commission -->

                                                <!--Start Status -->
                                                <div class="col-md-2">
                                                    <label>Status</label>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            v-model="FormData.is_credit" name="flexRadioDefault"
                                                            id="flexRadioDefault1">
                                                        <label>
                                                            Debt
                                                        </label>
                                                    </div>
                                                </div>
                                                <!-- End Status -->
                                            </div>

                                        </div>
                                        <div class="row d-flex justify-content-end">
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="text-md-right mt-4">
                                                        <button type="submit"
                                                            class="btn btn-primary mr-2 waves-effect waves-light">
                                                            Recharge
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <!-- End Form -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
